<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: null,
    },
  },
  computed: {
    hasContent() {
      return !!this.$slots.content;
    },
  },
};
</script>

<template>
  <div class="edit-box d-flex flex-column i-radius-2xl i-p-10">
    <div class="heading d-flex flex-row align-items-center">
      <div class="text d-flex flex-column flex-grow-1 i-gap-1">
        <div class="title i-text-button-2 i-text-neutral-120">{{ title }}</div>
        <div v-if="subtitle" class="subtitle i-text-body-3 i-text-neutral-110">
          {{ subtitle }}
        </div>
      </div>
      <slot name="right-side"></slot>
    </div>
    <div v-if="hasContent" class="content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.edit-box {
  background: $light-neutral-10;
  border: 1px solid $light-neutral-60;
}
</style>
